// extracted by css-extract-rspack-plugin
export default {"emptyState":"EmptyState-module__emptyState__xZs4Q","emptyStateHeading":"EmptyState-module__emptyStateHeading__VVp6H"};